<div class="page_wrapper">
  <app-header-new></app-header-new>

  <div class="container wrapper-page header-fix position-relative display-contents">
    <div class="row">
      <!-- <p class="font-size-15 font-weight-500">My Appointments</p> -->
      <div class="col-lg-12">
        <div class="card m-b-30">
          <div class="card-body">
            <p class="font-size-18 font-weight-500 text-color ml-md-1 ml-0 mb-4">My Appointments</p>
            <div class="row pl-md-5 pl-0">
              <div class="col-md-12 detail-tbl ">
                <form [formGroup]="findAppointmentForm">
                  <div class="row mb-3">
                    <div class="col-md-2">
                      <label class="font-size-17 mt-3">Select Members :</label>
                    </div>
                    <div class="col-md-3">
                      <select class="form-control" formControlName="pid">
                        <option *ngFor="let m of totalMembers" [value]="m?.pid">
                          {{m?.first_name}} {{m?.last_name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="font-size-17 mt-3 ml-md-5 ml-0">Choose Date :</label>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <div class="d-flex">
                        <input class="form-control" placeholder="Date of Appointment" name="appointmentDate"
                          ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false"
                          id="appointmentDate" formControlName="apDate" />
                        <div>
                          <button class="btn btn-outline-secondary button-height calendar rounded-0"
                            (click)="appointment.toggle()" type="button" id="AppointmentButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <button type="submit" name="find" class="btn btn-primary text-white"
                        (click)="getPatientAppointments()">FIND
                        APPOINTMENT</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid" *ngIf="appointments && appointments.length > 0">
    <div class="row">
      <div class="col-md-12 mt-5 detail-tbl">
        <div class="card m-b-30">
          <div class="card-body table-responsive">

            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="w-12">Appointment ID </th>
                  <th scope="col" class="w-20">Patient</th>
                  <th scope="col" class="w-20">Doctor</th>
                  <th scope="col" class="w-10">Date</th>
                  <th scope="col" class="w-10">Time</th>
                  <th scope="col" class="w-10">Details</th>
                  <th scope="col" class="w-12">Consultation Summary</th>
                </tr>
              </thead>

              <tr *ngFor="let app of appointments">
                <td class="font-size-15 text-color">{{app?.aptid}}</td>
                <td class="font-size-15 ">{{app?.patfirstname}} {{app?.patlastname}}</td>
                <td class="font-size-15 "> {{app?.phyfirstname}} {{app?.phylastname}}</td>
                <td class="font-size-15"> {{app?.apdate | date: dateFormat}} </td>
                <td class="font-size-15">{{app?.aptime}}</td>
                <td class="font-size-15 text-color">
                  <a [routerLink]="['/patient/appointment/'+app?.aptid]" class="text-color cursor">Click Here</a></td>
                <td class="font-size-15 text-color ">
                  <a class="cursor" (click)="goToPrescription(app)">Click Here</a>
                </td>
              </tr>
              <tbody>
                <tr>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="container-fluid" *ngIf="!appointments || appointments?.length === 0">
    <div class="row">
      <div class="col-lg-12">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 mt-2 text-center">
                <h5 class="text-danger">NO APPOINTMENTS FOUND</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer-new></app-footer-new>
</div>